module.exports = __webpack_public_path__ + "to.ec77d856.svg";